import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'hemisphere', 'Hemisphere', [["path",{"d":"M3 9a9 3 0 1 0 18 0a9 3 0 1 0 -18 0"}],["path",{"d":"M3 9a9 9 0 0 0 18 0"}]]);